import ParticipantItem from "../../../Content/Participants/ParticipantItem"
import Checkbox from "../../Checkbox"

import "./index.scss"

// NUDGE-ROW-CLICK 2026-07-09 (HANDOFF-web-lifecycle-to-p03-dev-verify.md item 4): the full row is
// now the click target, not just the checkbox. The checkbox no longer carries its own onClick --
// a click on it bubbles to the row handler below (it renders inside the row), so wiring both
// would double-toggle (checkbox click -> row handler fires once from bubbling + once from the
// checkbox's own handler -> net no-op). One handler, one source of truth.
const ListItem = ({ participant, checked, onClick }) => {
  return (
    <div
      className="people-ask-people-item"
      key={participant.id}
      role="button"
      tabIndex={0}
      onClick={() => onClick(participant)}
      onKeyDown={e => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault()
          onClick(participant)
        }
      }}>
      <ParticipantItem
        participant={participant}
        hideStatus
        className="people-ask-people-participant"
      />
      <div className="people-ask-people-checkbox">
        <Checkbox checked={checked} />
      </div>
    </div>
  )
}

export default ListItem
